module.exports = __webpack_public_path__ + "images/calendar-icon1d9dfac57973b2a77120f7abc20edd3b.png";